import React, {useState} from "react";
import {cloneDeep} from "lodash";
import {arrayIncludeItem} from "@app/utils/CommonUtils";
import Select from "react-select";
import {SavedListTabOptions} from "@pages/savedlist/common/Constant";

const InitSearchConditions = {
    'select_tabs': '',
    'saved_list_name': '',
    'created_start_date': '',
    'created_end_date': '',
}

const QuickSearchSavedList = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep(InitSearchConditions));
    const [searching, isSearching] = useState(false);

    const {onSearch} = props

    const onAddIndustryFunctionItem = (fieldName, value) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(searchConditions[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            searchConditions[fieldName] = arr
            setSearchConditions({...searchConditions})
        }
    }

    const onChangeSearchItem = (name, values) => {
        searchConditions[name] = values;
        setSearchConditions({...searchConditions});
    };

    const onSearchJobs = () => {
        return onSearch(searchConditions)
    }

    const onClearSearchCondition = () => {
        setSearchConditions(cloneDeep(InitSearchConditions));
    }
    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold">Search</h3>
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                    <i className="fas fa-minus"/>
                </button>
                <div className="card-tools pr-2">
                    <button
                        type='button'
                        className='btn btn-default mr-3'
                        onClick={() => onClearSearchCondition()}
                    >
                        {'Clear'}
                    </button>
                    <button
                        type='button'
                        className='btn btn-primary'
                        onClick={() => onSearchJobs()}
                        disabled={searching}
                    >
                        {searching ? 'Searching...' : 'Search'}
                    </button>
                </div>
            </div>
            <div className="card-body">
                <div className={"row"}>
                    <div className='col-sm-6'>
                        <label className={'w-100'}>Tên Tab</label>
                        <div style={{width: '100%'}}>
                            <Select options={SavedListTabOptions} isMulti
                                    value={searchConditions.select_tabs}
                                    onChange={value => {
                                        onChangeSearchItem('select_tabs', value);
                                    }}
                            />
                        </div>
                    </div>
                    <div className='col-sm-6'>
                        <div className='form-group'>
                            <label className={'w-100'}>Tên Saved list</label>
                            <input type='text' className='form-control' placeholder='Tên Saved list'
                                   value={searchConditions.saved_list_name}
                                   name={'saved_list_name'}
                                   onChange={event => onChangeSearchItem('saved_list_name', event.target.value)}/>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm-12'>
                    <label className={'w-100'}>Ngày tạo</label>
                    </div>
                    <div className=' col-sm-6'>
                        <div style={{width: '100%'}}>
                            <div className="form-group">
                                <input type="date"
                                       className="form-control" name={'created_start_date'}
                                       value={searchConditions.created_start_date}
                                       onChange={event => onChangeSearchItem('created_start_date', event.target.value)}
                                       maxLength="10" placeholder="mm/dd/yyyy" autoComplete="off"/>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-6'>
                        <div style={{width: '100%'}}>
                            <div className="form-group">
                                <input type="date"
                                       className="form-control" name={'created_end_date'}
                                       value={searchConditions.created_end_date}
                                       onChange={event => onChangeSearchItem('created_end_date', event.target.value)}
                                       maxLength="10" placeholder="mm/dd/yyyy" autoComplete="off"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QuickSearchSavedList;
